"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IDecisionUsecache = exports.IDecisionFrozen = exports.IDecisionInactive = exports.IDecisionPeriod = exports.IDecisionAction = exports.IDecisionTarget = exports.IDecisionType = void 0;
var IDecisionType;
(function (IDecisionType) {
    IDecisionType["EXCEEDED_THE_MAXIMUM_NUMBER_OF_ALLOWED_FAILED_AUTHORIZATIONS_MERCHANTFAILURELIMIT"] = "merchantFailureLimit";
    IDecisionType["EXCEEDED_THE_MAXIMUM_RATIO_OF_ALLOWED_FAILED_AUTHORIZATIONS_MERCHANTFAILURERATIO"] = "merchantFailureRatio";
    IDecisionType["EXCEEDED_THE_MAXIMUM_ALLOWED_SALE_TOTAL_VALUE_SALETOTALLIMIT"] = "saleTotalLimit";
    IDecisionType["EXCEEDED_THE_MAXIMUM_ALLOWED_REFUND_TOTAL_VALUE_REFUNDTOTALLIMIT"] = "refundTotalLimit";
    IDecisionType["EXCEEDED_THE_ALLOWED_MAXIMUM_PAYMENT_SIZE_INDIVIDUAL_TRANSACTION_AMOUNT_AVERAGESALECOUNTLIMIT"] = "averageSaleCountLimit";
    IDecisionType["EXCEEDED_THE_MAXIMUM_ALLOWED_RATIO_OF_REFUNDS_TO_SALES_MERCHANTREFUNDSALERATIO"] = "merchantRefundSaleRatio";
    IDecisionType["_MERCHANTPAYMENTSUCCESSLIMIT"] = "merchantPaymentSuccessLimit";
    IDecisionType["EXCEEDED_THE_MAXIMUM_ALLOWED_NUMBER_OF_FAILED_AUTHORIZATIONS_FOR_A_PARTICULAR_IP_ADDRESS_IPFAILURELIMIT"] = "ipFailureLimit";
    IDecisionType["EXCEEDED_THE_MAXIMUM_ALLOWED_RATIO_OF_FAILED_AUTHORIZATIONS_FOR_A_PARTICULAR_IP_ADDRESS_IPFAILURERATIO"] = "ipFailureRatio";
    IDecisionType["THE_MERCHANT_IS_NOT_ACTIVE_INACTIVEMERCHANT"] = "inactiveMerchant";
    IDecisionType["EXCEEDED_THE_MAXIMUM_ALLOWED_NUMBER_OF_FAILED_TRANSACTIONS_MERCHANTPAYMENTFAILURELIMIT"] = "merchantPaymentFailureLimit";
    IDecisionType["EXCEEDED_THE_MAXIMUM_ALLOWED_NUMBER_OF_TRANSACTIONS_WITHOUT_AUTHORIZATIONS_MERCHANTCAPTUREWITHOUTAUTHLIMIT"] = "merchantCaptureWithoutAuthLimit";
    IDecisionType["REFUND_TRANSACTION_DOES_NOT_HAVE_AN_ASSOCIATED_SALE_TRANSACTION_REFUNDWITHOUTSALE"] = "refundWithoutSale";
    IDecisionType["EXCEEDED_THE_MAXIMUM_NUMBER_OF_REFUND_TRANSACTIONS_THAT_DO_NOT_HAVE_ASSOCIATED_SALE_TRANSACTIONS_REFUNDWITHOUTSALELIMIT"] = "refundWithoutSaleLimit";
    IDecisionType["EXCEEDED_THE_MAXIMUM_AUTHORIZED_VALUE_FOR_TRANSACTIONS_WITH_FAILED_AUTHORIZATIONS_CAPTUREABOVEAUTHLIMIT"] = "captureAboveAuthLimit";
    IDecisionType["TRANSACTION_FRAUD_SCORE_FRAUDSCORE"] = "fraudScore";
    IDecisionType["CVV_CVV"] = "cvv";
    IDecisionType["AVS_AVS"] = "avs";
    IDecisionType["AAVS_AAVS"] = "aavs";
    IDecisionType["DUPLICATE_TRANSACTION_DUPLICATETXN"] = "duplicateTxn";
    IDecisionType["TRANSACTION_MATCHES_MERCHANT_DETAILS_MERCHANTMATCH"] = "merchantMatch";
    IDecisionType["TRANSACTION_TRIGGERS_CURRENCY_CONVERSION_CURRENCYCONVERSION"] = "currencyConversion";
    IDecisionType["TRANSACTION_SETTLED_CURRENCY_MISMATCH_SETTLEDCURRENCYMISMATCH"] = "settledCurrencyMismatch";
    IDecisionType["INITIAL_TRANSACTION_OF_THIS_TYPE_INITIALTXN"] = "initialTxn";
    IDecisionType["EXCEEDED_THE_LIMIT_OF_TRANSACTIONS_WITH_EQUAL_TOTALS_SIMILARTOTALLIMIT"] = "similarTotalLimit";
    IDecisionType["EXCEEDED_THE_RATIO_OF_TRANSACTIONS_WITH_EQUAL_TOTALS_SIMILARTOTALRATIO"] = "similarTotalRatio";
    IDecisionType["MINIMUM_TRANSACTION_AMOUNT_SALETOTALMINIMUM"] = "saleTotalMinimum";
    IDecisionType["EXCEEDED_THE_MAXIMUM_ALLOWED_NUMBER_OF_AUTHORIZATIONS_LIMIT"] = "limit";
    IDecisionType["_RATIO"] = "ratio";
    IDecisionType["CHECK_THE_TRANSACTION_DATA_AGAINST_A_CUSTOM_WATCHLIST_TXNWATCHLIST"] = "txnWatchlist";
})(IDecisionType = exports.IDecisionType || (exports.IDecisionType = {}));
var IDecisionTarget;
(function (IDecisionTarget) {
    IDecisionTarget["TERMINAL_ACTIVATION_ACTIVATION"] = "activation";
    IDecisionTarget["APPLY_THIS_DECISION_DURING_TRANSACTION_AUTHORIZATION_AUTH"] = "auth";
    IDecisionTarget["IMMEDIATELY_AFTER_AUTHORIZATION_POSTAUTH"] = "postauth";
    IDecisionTarget["APPLY_THIS_DECISION_DURING_TRANSACTION_CAPTURE_CAPTURE"] = "capture";
    IDecisionTarget["APPLY_THIS_DECISION_WHEN_PROCESSING_A_REFUND_REFUND"] = "refund";
    IDecisionTarget["_CREATEENTITY"] = "createEntity";
    IDecisionTarget["UNDERWRITING_UNDERWRITING"] = "underwriting";
    IDecisionTarget["PREBOARD_PREBOARD"] = "preboard";
    IDecisionTarget["CHECK_THE_MERCHANT_AFTER_THEY_ARE_BOARDED_POSTBOARD"] = "postboard";
    IDecisionTarget["CHECK_THE_MERCHANT_WHEN_THEY_PROCESS_A_TRANSACTION_TXN"] = "txn";
    IDecisionTarget["CHECK_THE_MERCHANT_WHEN_THEIR_TRANSACTION_VOLUME_HITS_A_CERTAIN_AMOUNT_TXNVOLUME"] = "txnVolume";
    IDecisionTarget["CHECK_THE_MERCHANT_WHEN_A_PAYOUT_OCCURS_PAYOUT"] = "payout";
    IDecisionTarget["CHECK_THE_MERCHANT_WHEN_THE_VOLUME_OF_PAYOUTS_TO_THE_MERCHANT_HITS_A_CERTAIN_AMOUNT_PAYOUTVOLUME"] = "payoutVolume";
})(IDecisionTarget = exports.IDecisionTarget || (exports.IDecisionTarget = {}));
var IDecisionAction;
(function (IDecisionAction) {
    IDecisionAction[IDecisionAction["NO_ACTION_0"] = 0] = "NO_ACTION_0";
    IDecisionAction[IDecisionAction["FOR_TXN_DECISION_BLOCK_1"] = 1] = "FOR_TXN_DECISION_BLOCK_1";
    IDecisionAction[IDecisionAction["FOR_TXN_DECISION_HOLD_3"] = 3] = "FOR_TXN_DECISION_HOLD_3";
    IDecisionAction[IDecisionAction["FOR_TXN_DECISION_RESERVE_4"] = 4] = "FOR_TXN_DECISION_RESERVE_4";
    IDecisionAction[IDecisionAction["BLOCK_CURRENT_ACTIVITY_NO_CHANGE_FOR_MERCHANT_5"] = 5] = "BLOCK_CURRENT_ACTIVITY_NO_CHANGE_FOR_MERCHANT_5";
    IDecisionAction[IDecisionAction["DEFAULT_6"] = 6] = "DEFAULT_6";
})(IDecisionAction = exports.IDecisionAction || (exports.IDecisionAction = {}));
var IDecisionPeriod;
(function (IDecisionPeriod) {
    IDecisionPeriod["DAYS_DAYS"] = "days";
    IDecisionPeriod["WEEKS_WEEKS"] = "weeks";
    IDecisionPeriod["MONTHS_MONTHS"] = "months";
    IDecisionPeriod["YEARS_YEARS"] = "years";
    IDecisionPeriod["SECONDS_SECONDS"] = "seconds";
    IDecisionPeriod["MINUTES_MINUTES"] = "minutes";
    IDecisionPeriod["YEARS_HOURS"] = "hours";
})(IDecisionPeriod = exports.IDecisionPeriod || (exports.IDecisionPeriod = {}));
var IDecisionInactive;
(function (IDecisionInactive) {
    IDecisionInactive[IDecisionInactive["ACTIVE_0"] = 0] = "ACTIVE_0";
    IDecisionInactive[IDecisionInactive["INACTIVE_1"] = 1] = "INACTIVE_1";
})(IDecisionInactive = exports.IDecisionInactive || (exports.IDecisionInactive = {}));
var IDecisionFrozen;
(function (IDecisionFrozen) {
    IDecisionFrozen[IDecisionFrozen["NOT_FROZEN_0"] = 0] = "NOT_FROZEN_0";
    IDecisionFrozen[IDecisionFrozen["FROZEN_1"] = 1] = "FROZEN_1";
})(IDecisionFrozen = exports.IDecisionFrozen || (exports.IDecisionFrozen = {}));
var IDecisionUsecache;
(function (IDecisionUsecache) {
    IDecisionUsecache[IDecisionUsecache["DISABLED_0"] = 0] = "DISABLED_0";
    IDecisionUsecache[IDecisionUsecache["ENABLED_1"] = 1] = "ENABLED_1";
})(IDecisionUsecache = exports.IDecisionUsecache || (exports.IDecisionUsecache = {}));
